<template>
  <!-- NOTE (TEMPLATE) to show the admins login page -->

  <div
    class="app animated fadeIn flex-row align-items-center adminBack"
    v-if="pageLoaded"
  >
    <Loading />
    <b-modal
      id="resetPassModal"
      ref="resetPassModal"
      header-bg-variant="primary"
      header-text-variant="white"
      class="text-center"
      size="md"
      centered
    >
      <template v-slot:modal-header>
        <h4>بازیابی رمز عبور</h4>
      </template>
      <template v-slot:modal-footer>
        <b-button
          variant="danger"
          size="lg"
          class="btn-radius px-8 py-2 ml-2"
          @click="closeResetPass()"
          >لغو</b-button
        >
      </template>
      <div class="container">
        <b-row class="justify-content-center">
          <b-col md="10">
            <div v-if="!codeSent">
              <p>
                لطفا شماره تلفن همراه خود را وارد نموده تا کد بازیابی برای شما
                ارسال گردد
              </p>
              <b-input-group class="mb-3">
                <b-input-group-prepend>
                  <b-input-group-text>
                    <i class="icon-user"></i>
                  </b-input-group-text>
                </b-input-group-prepend>
                <masked-input
                  dir="ltr"
                  type="text"
                  mask="\0911 111 1111"
                  v-model="mobile"
                  class="form-control"
                  placeholder="09__ ___ ____"
                  :disabled="codeSent"
                />
              </b-input-group>
              <input type="text" v-model="company" style="display: none" />
              <!-- <b-form-group>
                <vue-recaptcha @verify="actCaptchaVerify" :sitekey="sitekey">
                </vue-recaptcha>
              </b-form-group> -->
              <b-button
                v-if="!codeSent"
                type="submit"
                variant="primary"
                @click="sendCode()"
                style="border: 0"
                :disabled="busy || !mobile"
                class="btn-radius px-8 py-2"
              >
                <i class="icon-login"></i>ارسال کد بازیابی
              </b-button>
            </div>
            <div v-else>
              <p>
                لطفا کدی را که اکنون به شما پیامک کردیم را به همراه رمز عبور
                جدید وارد نمایید
              </p>
              <b-input-group class="mb-4">
                <b-input-group-prepend>
                  <b-input-group-text>
                    <i class="icon-lock"></i>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input
                  trim
                  type="number"
                  :no-wheel="true"
                  v-model="activationCode"
                  class="form-control"
                  placeholder="کد ارسالی"
                  autofocus
                />
              </b-input-group>
              <b-input-group class="mb-4">
                <b-input-group-prepend>
                  <b-input-group-text>
                    <i class="icon-lock"></i>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input
                  trim
                  type="password"
                  v-model="newPass"
                  class="form-control"
                  placeholder="رمز عبور جدید"
                  @input="passStrength"
                  autofocus
                />
              </b-input-group>
              <b-row>
                <b-col>
                  <p
                    class="pass"
                    :class="{ 'pass--passed': newPass.length > 7 }"
                  >
                    <i
                      class="frmIcon fa"
                      :class="newPass.length > 7 ? 'fa-check' : 'fa-times'"
                    ></i>
                    حداقل ۸ نویسه
                  </p>
                </b-col>
                <b-col>
                  <p
                    class="pass"
                    :class="{ 'pass--passed': rec_has_uppercase }"
                  >
                    <i
                      class="frmIcon fa"
                      :class="rec_has_uppercase ? 'fa-check' : 'fa-times'"
                    ></i>
                    دارای حروف بزرگ باشد
                  </p>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <p
                    class="pass"
                    :class="{ 'pass--passed': rec_has_lowercase }"
                  >
                    <i
                      class="frmIcon fa"
                      :class="rec_has_lowercase ? 'fa-check' : 'fa-times'"
                    ></i>
                    دارای حروف کوچک باشد
                  </p>
                </b-col>
                <b-col>
                  <p class="pass" :class="{ 'pass--passed': rec_has_number }">
                    <i
                      class="frmIcon fa"
                      :class="rec_has_number ? 'fa-check' : 'fa-times'"
                    ></i>
                    دارای عدد باشد
                  </p>
                </b-col>
              </b-row>

              <b-input-group class="mb-4">
                <b-input-group-prepend>
                  <b-input-group-text>
                    <i class="icon-lock"></i>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input
                  trim
                  type="password"
                  v-model="repeatNewPass"
                  class="form-control"
                  placeholder="تکرار رمز عبور جدید"
                  autofocus
                  @keyup.enter.native="
                    !busy && newPass && repeatNewPass && activationCode
                      ? resetPass()
                      : ''
                  "
                />
              </b-input-group>
              <b-row>
                <b-col cols="6">
                  <b-button
                    type="submit"
                    variant="primary"
                    @click="resetPass()"
                    style="border: 0"
                    :disabled="
                      busy || !newPass || !repeatNewPass || !activationCode
                    "
                  >
                    <i class="icon-login"></i>تغییر رمز </b-button
                  >&nbsp;
                </b-col>
                <b-col cols="6" class="text-left">
                  <b-button
                    type="submit"
                    variant="info"
                    @click="sendCode()"
                    style="border: 0"
                    :disabled="sendAgainDisbaled"
                    class="btn-radius px-8 py-2"
                  >
                    <b-icon icon="arrow-counterclockwise"></b-icon>ارسال مجدد کد
                    <span v-if="countdown != 0">{{ toHHMMSS(countdown) }}</span>
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <div class="container">
      <div>
        <BannerSlider :images="banners" :clickable="true" :type="'download'" />
      </div>
      <b-row class="justify-content-center">
        <h1 class="mb-2 mt-6 text-white" style="color: #fff">
          همکار گرامی، به سامانه تقسیم کار ملی خوش آمدید!
        </h1>

        <b-col md="8" class="px-0">
          <b-card-group>
            <b-card no-body class="login-card p-4 pb-0">
              <b-card-body>
                <p class="text-muted">
                  برای ورود به سیستم،لطفا نام کاربری و رمز ورود خود را وارد
                  نمایید.
                </p>
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="icon-user"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>

                  <b-form-input
                    trim
                    type="text"
                    v-model="username"
                    class="form-control"
                    placeholder="نام کاربری"
                  />
                </b-input-group>
                <input type="text" v-model="company" style="display: none" />
                <b-input-group class="mb-4">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="icon-lock"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    trim
                    type="password"
                    v-model="password"
                    class="form-control"
                    placeholder="رمز ورود"
                    autocomplete="current-password"
                    @keyup.enter.native="
                      !busy && username && password ? gotoDashboard() : ''
                    "
                  />
                </b-input-group>
                <!-- <b-form-group>
                  <vue-recaptcha
                    @verify="captchaVerify"
                    sitekey="6LfYhvAZAAAAAK42dfq5KUQXQUYZZgxnpAwgEwU-"
                  >
                  </vue-recaptcha>
                </b-form-group> -->
                <b-row>
                  <b-col cols="6">
                    <b-button
                      v-if="!isBusy"
                      type="submit"
                      variant="primary"
                      @click="gotoDashboard()"
                      style="border: 0; color: white"
                      :disabled="busy || isBusy || !username || !password"
                      class="btn-radius px-8 py-2"
                    >
                      <i class="icon-login"></i>ورود
                    </b-button>

                    <b-spinner v-else class="align-middle"></b-spinner>
                  </b-col>
                  <b-col>
                    <a
                      class="text-primary"
                      style="float: left; cursor: pointer"
                      @click="showResetPass()"
                      :disabled="isBusy"
                      >رمز عبور خود را فراموش کرده اید؟</a
                    >
                  </b-col>

                  <b-col cols="6" class="text-right"></b-col>
                </b-row>
              </b-card-body>
              <div>
                <b-row></b-row>
              </div>
            </b-card>
          </b-card-group>
          <b-row class="justify-content-center mt-5">
            <v-btn
              color="purple darken-1"
              @click="goTo('researcher')"
              class="m-1 white--text btn-radius"
              width="136"
              height="42"
              elevation="0"
            >
              ورود پژوهشگر
            </v-btn>
            <v-btn
              color="red darken-3"
              @click="goTo('ref')"
              class="m-1 white--text btn-radius"
              width="136"
              height="42"
              elevation="0"
            >
              ورود داور
            </v-btn>
            <!-- <v-btn
              color="deep-orange lighten-1"
              @click="goTo('accelerator')"
              class="m-1 white--text btn-radius"
              width="136"
              height="42"
              elevation="0"
            >
              ورود شتاب‌دهنده
            </v-btn> -->
            <!-- <v-btn
              color="indigo"
              @click="goTo('company')"
              class="m-1 white--text btn-radius"
              width="136"
              height="42"
              elevation="0"
            >
              ورود شرکت
            </v-btn> -->
            <v-btn
              color="teal"
              @click="goTo('uni')"
              class="m-1 white--text btn-radius"
              width="136"
              height="42"
              elevation="0"
            >
              ورود دانشگاه
            </v-btn>
          </b-row>
          <hr class="mt-6" />
          <b-row class="justify-content-center mt-3">
            <v-btn
              color="blue darken-1"
              to="/map"
              class="m-1 white--text btn-radius"
              height="42"
              elevation="0"
            >
              <v-icon class="me-1">mdi-map</v-icon>نقشه تعاملی زیست فناوری
            </v-btn>
            <v-btn
              color="yellow darken-1"
              class="m-1 black--text btn-radius"
              height="42"
              elevation="0"
              @click="faqDialog = true"
            >
              <v-icon class="me-1">mdi-frequently-asked-questions</v-icon>سوالات
              متداول
            </v-btn>
            <v-btn
              color="orange darken-1"
              href="https://api.biodcportal.com/setad/public/طرح%20تقسیم%20کار%20ملی%20زیست%20فناوری.pdf"
              class="m-1 white--text btn-radius"
              height="42"
              elevation="0"
            >
              راهنمای آشنایی با طرح تقسیم کار ملی زیست فناوری
            </v-btn>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <ChangeLog />
    <FaqDialogue :faq-dialog.sync="faqDialog" />
  </div>
</template>

<script>
import MaskedInput from "../../node_modules/vue-masked-input";
import VueRecaptcha from "vue-recaptcha";
import md5 from "js-md5";
import utilities from "../mixins/utilities";
import createHumanVerification from "../mixins/humanVerification";
import BannerSlider from "../components/BannerSlider.vue";
const ChangeLog = () => import("../components/ChangeLog");
const FaqDialogue = () => import("../components/FaqDialogue");

export default {
  name: "Login",
  components: {
    MaskedInput,
    VueRecaptcha,
    ChangeLog,
    FaqDialogue,
    BannerSlider,
  },
  mixins: [utilities],
  data() {
    return {
      username: "",
      password: "",
      recaptcha: null,
      actCaptcha: null,
      busy: false,
      isBusy: false,

      codeSent: false,
      activationCode: "",
      newPass: "",
      repeatNewPass: "",
      countdown: 60,
      sendAgainDisbaled: false,
      mobile: "",
      rec_has_number: false,
      rec_has_lowercase: false,
      rec_has_uppercase: false,
      pageLoaded: false,
      faqDialog: false,

      humanVerifier: null,
      company: null,
      banners: [],
    };
  },
  watch: {
    codeSent: function (val, oldVal) {
      // NOTE (w-codeSent) to give the code again after 60 second
      this.countdown = 60;

      if (val == true) {
        this.sendAgainDisbaled = true;
        this.countDownTimer();
      }
    },
    countdown: function (val, oldVal) {
      // NOTE (w-countdown) to countdown for sending code again
      if (val == 0) {
        this.sendAgainDisbaled = false;
      } else {
        this.sendAgainDisbaled = true;
      }
    },
  },
  computed: {},
  methods: {
    goTo(role) {
      if (role == "researcher") {
        this.$router.push("/login");
      } else if (role == "ref") {
        this.$router.push("/reflogin");
      } else if (role == "uni") {
        this.$router.push("/unilogin");
      } else if (role == "company") {
        this.$router.push("/companyLogin");
      } else if (role == "accelerator") {
        this.$router.push("/acceleratorLogin");
      }
    },
    passStrength() {
      this.rec_has_number = /\d/.test(this.newPass);
      this.rec_has_lowercase = /[a-z]/.test(this.newPass);
      this.rec_has_uppercase = /[A-Z]/.test(this.newPass);
    },
    captchaVerify(response) {
      this.recaptcha = response;
    },
    actCaptchaVerify(response) {
      this.actCaptcha = response;
    },
    async gotoDashboard() {
      // NOTE (m-gotoDashboard) to go to the admins dashboard
      this.isBusy = true;
      if (this.company)
        return this.toast(
          "شما ربات تشخیص داده شدید. دوباره تلاش نمایید.",
          "error"
        );
      const token = await this.humanVerifier.executeHumanCheck("login");

      this.$http
        .post(this.baseUrl + "/setad/authentication/recaptchAdminLogin", {
          mobile: this.username,
          password: md5(this.password),
          // NOTE sending captcha code to backend
          // captcha: this.recaptcha,
          humanToken: token,
        })
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            localStorage.setItem("userId", res.data.token);
            if (res.data.role == "manager") {
              localStorage.setItem("role", "manager");
              this.$route.query.return
                ? this.$router.push(this.$route.query.return)
                : this.$router.push("/manager/dashboard");
            } else if (res.data.role == "head") {
              localStorage.setItem("role", "head");
              this.$route.query.return
                ? this.$router.push(this.$route.query.return)
                : this.$router.push("/head/dashboard");
            } else if (res.data.role == "companyManager") {
              localStorage.setItem("role", "companyManager");
              this.$route.query.return
                ? this.$router.push(this.$route.query.return)
                : this.$router.push("/companyManager/dashboard");
            } else {
              localStorage.setItem("role", "admin");
              this.$route.query.return
                ? this.$router.push(this.$route.query.return)
                : this.$router.push("/admin/dashboard");
            }
          } else {
            this.humanVerifier.destroy();
            this.humanVerifier.init();
            this.recaptcha = null;
            const title = (
              <div>
                <h5>خطا</h5>
                <span>خطایی رخ داده است. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.humanVerifier.destroy();
          this.humanVerifier.init();
          this.recaptcha = null;
          this.isBusy = false;
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    toHHMMSS(value) {
      // NOTE (m-toHHMMSS) determine the order of hours, minutes and seconds
      var sec_num = parseInt(value, 10); // don't forget the second param
      var hours = Math.floor(sec_num / 3600);
      var minutes = Math.floor((sec_num - hours * 3600) / 60);
      var seconds = sec_num - hours * 3600 - minutes * 60;

      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      return minutes + ":" + seconds;
    },
    countDownTimer() {
      //NOTE (m-countDownTimer) to start counting down after 1 second
      if (this.countdown > 0) {
        setTimeout(() => {
          this.countdown -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
    showResetPass() {
      this.$refs["resetPassModal"].show();
    },
    closeResetPass() {
      this.$refs["resetPassModal"].hide();
      this.activationCode = "";
      this.newPass = "";
      this.repeatNewPass = "";
      this.mobile = "";
      this.codeSent = false;
    },
    async sendCode() {
      // NOTE (m-sendCode) to send the code
      this.mobile = this.mobile.split(" ").join("");
      this.codeSent = false;
      this.busy = true;
      if (this.company)
        return this.toast(
          "شما ربات تشخیص داده شدید. دوباره تلاش نمایید.",
          "error"
        );
      const token = await this.humanVerifier.executeHumanCheck("login");

      this.$http
        .post(this.baseUrl + "/setad/authentication/adminSenCode", {
          mobile: this.mobile,
          // captcha: this.actCaptcha,
          humanToken: token,
        })
        .then((res) => {
          this.codeSent = true;
          this.busy = false;
        })
        .catch((err) => {
          this.humanVerifier.destroy();
          this.humanVerifier.init();
          this.actCaptcha = null;
          console.log(err);
          this.toast(err.response.data, "error");
          this.busy = false;
        });
    },
    resetPass() {
      if (
        this.rec_has_number &&
        this.rec_has_lowercase &&
        this.rec_has_uppercase &&
        this.newPass.length > 7
      ) {
        if (this.newPass == this.repeatNewPass) {
          this.busy = true;
          this.$http
            .post(this.baseUrl + "/setad/authentication/adminResPass", {
              mobile: this.mobile,
              password: md5(this.newPass),
              activationCode: this.activationCode,
            })
            .then((res) => {
              this.toast(res.data, "success");
              this.busy = false;
              this.$refs["resetPassModal"].hide();
            })
            .catch((err) => {
              console.log(err);
              this.toast(err.response.data, "error");
              this.busy = false;
            });
        } else {
          this.toast("رمز عبور و تکرار آن باید منطبق باشند", "error");
        }
      } else {
        this.toast(
          "لطفا جهت حفظ امنیت اطلاعات خود موارد خواسته شده را در رمز خود اعمال کنید",
          "error"
        );
      }
    },
    getBannersData() {
      this.isBusy = true;
      this.$http
        .get(this.baseUrl + "/setad/authentication/banners/")
        .then((res) => {
          this.banners = res.data;
          this.isBusy = false;
        })
        .catch((err) => {
          this.isBusy = false;
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
  },
  created() {
    this.humanVerifier = createHumanVerification();
  },
  beforeDestroy() {
    this.humanVerifier.destroy();
  },
  mounted() {
    this.$http
      .post(this.baseUrl + "/setad/authentication/isSystemUp")
      .then((res) => {
        if (res.data) this.pageLoaded = true;
        else this.$router.push("/comingSoon");
      })
      .catch((err) => {
        this.$router.push("/comingSoon");
      });
    this.humanVerifier.init();
    this.getBannersData();
  },
};
</script>
<style scoped>
.adminBack {
  background-image: url("../assets/images/adminBack.png");

  background-size: cover;
}
/* pass validation style */
.pass {
  font-size: 13px;
}
.pass--passed {
  color: #717b85;
}
.frmIcon {
  color: #eb0029;
}
.pass--passed .frmIcon {
  color: #0fa140;
}
</style>
